import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/external_download.svg';
const ExternalDownload = () => React.createElement(IconSvg, null);
export default ExternalDownload;
